export const handleError = ({ error, event }) => {
	return {
		message: error?.message ?? 'Something went wrong'
	};
};
